// extracted by mini-css-extract-plugin
export default {"tableSpace":"index_tableSpace__JMHzs"};